import { z } from 'zod';
import { FlowTestAssertionSchema } from './assertion.js';
import { FlowTestStartPayloadSchema } from './startPayload.js';
/** The expected terminal state is independent of assertions about individual blocks. */
export const FlowTestExpectedRunStateSchema = z.enum(['Completed', 'Failed']);
export const FlowTestExpectedRunState = FlowTestExpectedRunStateSchema.enum;
/** Block IDs keep mocks stable across non-unique names and renames. */
export const FlowTestBlockMocksByIdSchema = z.record(z.string(), z.unknown());
const BlockConfigMocksByIdSchema = z.record(z.string(), z.record(z.string(), z.unknown()));
/** Unsafe blocks that a builder explicitly allows the case to run for real. */
export const FlowTestLiveBlockIdsSchema = z.array(z.string()).default([]);
/** The storage-independent contract generated and accepted for one runnable test case. */
export const RunnableFlowTestCaseSchema = z.object({
    name: z.string().min(1),
    description: z.string().optional(),
    startPayload: FlowTestStartPayloadSchema,
    expectedRunState: FlowTestExpectedRunStateSchema.default(FlowTestExpectedRunState.Completed),
    blockOutputMocks: FlowTestBlockMocksByIdSchema.default({}),
    blockConfigMocks: BlockConfigMocksByIdSchema.default({}),
    liveBlockIds: FlowTestLiveBlockIdsSchema,
    assertions: z.array(FlowTestAssertionSchema).min(1),
});
/** Removes defaults before making fields optional so an omitted patch field stays omitted. */
export const PartialRunnableFlowTestCaseSchema = RunnableFlowTestCaseSchema.extend({
    expectedRunState: FlowTestExpectedRunStateSchema,
    blockOutputMocks: FlowTestBlockMocksByIdSchema,
    blockConfigMocks: BlockConfigMocksByIdSchema,
    liveBlockIds: z.array(z.string()),
}).partial();
//# sourceMappingURL=testCase.js.map